import React from 'react';
import { generateToolbarSettings } from './../richtextgroup/RichtextGroupHelpers';
import { getPredefinedVar, tooltipFormatter } from '../../../editor/core-ui/tooltip/highed.tooltip.helper.utils';
import SelectWidget from '../SelectWidget';
import { editorStyles } from 'shared/editor/PublishHelper';
import PlusIcon from '../PlusIcon';
import store from 'redux/store';
import { updateCustomizedBulkAction } from 'pages/ChartEditorPage/actions/chartEditor';

export const generateToolbars = (
  aggregatedOptions,
  settings,
  headerRef,
  bodyRef,
  onChange,
  inlineSettings,
  setInlineSettings
) => {
  const { toolbar: headerToolbar, toolbarOptions: headerToolbarOptions } = generateToolbarSettings({
    type: 'chart',
    settings,
    id: 'toolbar-74e6df45-2835-4dde-b418-4934i93',
    options: aggregatedOptions?.tooltip ?? {},
    ref: headerRef,
    onChange,
    inlineSettings,
    setInlineSettings,
    aggregatedOptions,
    fields: ['bold', 'underline', 'italic', 'fontSize', 'color', 'font'],
    className: 'p-2',
    noHighchartOptions: true
  });

  const { toolbar: bodyToolbar, toolbarOptions: bodyToolbarOptions } = generateToolbarSettings({
    type: 'chart',
    settings,
    id: 'toolbar-74e6df45-2835-4dde-b418-2345tfvsca3',
    options: aggregatedOptions?.tooltip ?? {},
    ref: bodyRef,
    onChange,
    inlineSettings,
    setInlineSettings,
    aggregatedOptions,
    fields: ['bold', 'underline', 'italic', 'fontSize', 'color', 'font'],
    className: 'p-2',
    noHighchartOptions: true
  });

  return {
    headerToolbar,
    headerToolbarOptions,
    bodyToolbar,
    bodyToolbarOptions
  };
};

export const generateDropdown = (dropdownOptions, onChange, value, addSelectedDropdownValue, label) => (
  <div className="relative p-[5px] w-full">
    <div className="text-ev-navy-blue font-bold mb-2">{label}</div>
    <div className="flex w-full gap-2 content-center">
      <div className="w-full">
        <SelectWidget selectOptions={dropdownOptions} onChange={onChange} value={value} customStyles={editorStyles} />
      </div>

      <PlusIcon onClick={addSelectedDropdownValue} />
    </div>
  </div>
);

export const defaultTooltipConfig = {
  tooltip: {
    formatter: tooltipFormatter,
    useHTML: true
  },
  everviz: {
    tooltip: {
      useEvervizHelper: true,
      options: {
        vars: {}
      }
    }
  }
};

export const getValue = (type, chart, aggregatedOptions) => {
  if (chart && chart.series && chart?.series?.[0]?.tooltipOptions) {
    return getPredefinedVar(chart.series[0].tooltipOptions, type);
  }
  if (aggregatedOptions?.tooltip?.[type]) {
    return getPredefinedVar(aggregatedOptions?.tooltip, type);
  }
  return '';
};

const updateCustomizedBulk = (options) => store.dispatch(updateCustomizedBulkAction({ options }));
export const onChange = (varName, newValue, aggregatedOptions) => {
  const text = newValue.val;

  if (aggregatedOptions?.tooltip?.[varName] && aggregatedOptions?.tooltip?.[varName] === text) {
    return;
  }

  let options = {
    ...(aggregatedOptions?.tooltip ?? {}),
    [varName]: text
  };

  updateCustomizedBulk({
    tooltip: {
      ...options,
      footerFormat: '',
      formatter: tooltipFormatter,
      useHTML: true
    },
    everviz: {
      tooltip: {
        useEvervizHelper: true,
        options: {
          vars: {}
        }
      }
    }
  });
};
